import { Report } from '@ui/Report';
import React, { ComponentProps, FC } from 'react';

type TextProps = ComponentProps<typeof Report.Text>;

type LifecycleReportTextProps = {
  lifecycleLabel: string;
  as?: TextProps['as'];
} & Omit<TextProps, 'children' | 'as'>;

/**
 * Just a simple component to easily keep the styling in the report
 * @param lifecycleLabel Only the lifecycle text label, no prefixes or suffixes
 */
export const LifecycleReportText: FC<LifecycleReportTextProps> = ({
  as = 'h6',
  lifecycleLabel,
  ...restProps
}) => (
  <Report.Text
    as={as}
    textTransform="uppercase"
    color="neutral.medium"
    {...restProps}
  >
    lifecycle <strong>{lifecycleLabel || 'N/A'}</strong>
  </Report.Text>
);
